<ng-container *ngIf="posts">
  <div class="header-title header-msg title">
    <span [attr.data-translate]="'movie-template-a.menu.socialUpdates'" i18n="@@movie-template-a.menu.socialUpdates"
      >Social updates</span
    >
    <a
      class="button news-view-all view-all-header viewAll"
      [attr.data-translate]="'public.slider.viewAll'"
      [routerLink]="['/social']"
      i18n="@@public.slider.viewAll"
    >
      View all
    </a>
  </div>
  <div class="posts-wrapper">
    <div *ngFor="let post of posts" class="post">
      <div class="post-header">
        <div class="post-author-pic-container">
          <img class="author-picture" [src]="post.authorPicture" [alt]="post.authorName + ' picture'" />
        </div>
        <div class="post-body">
          <div class="post-body-header">
            <fa-icon *ngIf="getIcon(post.socialNetwork) as _icon" [icon]="_icon" size="lg"></fa-icon>
            <div class="post-author-name">
              {{ post.authorName }}
            </div>
            <div class="post-created-date">{{ post.dateCreate }}</div>
          </div>
          <p class="post-text text" [innerHTML]="post.message | readMore: { link: post.link } | safe: 'html'"></p>
        </div>
      </div>
      <video
        *ngIf="post.attachment && post.attachment.length > 0 && post.type === 'video'"
        [src]="post.attachment"
        controls="true"
        controlslist="nodownload"
      ></video>
      <img
        class="post-atachment"
        *ngIf="post.attachment && post.attachment.length > 0 && post.type === 'img'"
        [src]="post.attachment"
        [alt]="post.authorName + ' main picture'"
      />
    </div>
  </div>
</ng-container>
